import { productSidebar } from './productCatalog'

const sys = (file) => `/images/systems/${file}`
const brochure = (file) => `/images/brochure/${file}`
const pathway = (file) => `/images/pathway/${file}`
const group = (file) => `/images/groups/${file}`

/** 五大类分组：色调、图标与 Banner 背景图 */
export const groupVisuals = {
  system: {
    tone: 'system',
    icon: 'software',
    background: group('group-system.png'),
  },
  education: {
    tone: 'education',
    icon: 'education',
    background: group('group-education.png'),
  },
  robotics: {
    tone: 'robotics',
    icon: 'robotics',
    background: group('group-robotics.png'),
    bgSize: 'auto 76%',
    bgPosition: '72% center',
    bgColor: '#111116',
  },
  'agv-group': {
    tone: 'agv',
    icon: 'agv',
    background: group('group-agv.png'),
  },
  automation: {
    tone: 'automation',
    icon: 'automation',
    background: group('group-automation.png'),
  },
}

/** 子分类展示图：优先用清晰产品/界面图，不用宣传册 PDF 页 */
export const categoryVisuals = {
  software: sys('power-curve.png'),
  'energy-system': sys('pv-dashboard.png'),
  iiot: brochure('img-p17-2.jpeg'),
  humanoid: pathway('humanoid-service.png'),
  quadruped: pathway('quadruped-white.png'),
  'ai-custom': pathway('ai-training.png'),
  drone: brochure('img-p6-4.png'),
  agv: pathway('forklift-agv.png'),
  'mobile-platform': pathway('mobile-platform.png'),
  'automation-line': brochure('img-p7-5.jpeg'),
  'original-products': pathway('composite-robot.png'),
  'case-showcase': brochure('img-p11-3.jpeg'),
  'service-clients': brochure('img-p36-2.jpeg'),
  'smart-line': brochure('img-p11-3.jpeg'),
  'estun-trainer': brochure('img-p11-5.jpeg'),
  'auto-line-trainer': brochure('img-p12-3.jpeg'),
  'robot-ops': brochure('img-p12-5.jpeg'),
  'sensor-box': brochure('img-p13-2.jpeg'),
  'sensor-lab': brochure('img-p13-4.jpeg'),
  electrician: brochure('img-p14-4.jpeg'),
  'electric-electronic': brochure('img-p14-2.jpeg'),
  'network-platform': brochure('img-p15-2.jpeg'),
  'plc-trainer': brochure('img-p16-2.jpeg'),
  'mechanical-assembly': brochure('img-p16-4.jpeg'),
  'welding-station': brochure('img-p17-4.jpeg'),
  'digital-resource': brochure('img-p9-5.jpeg'),
  'digital-textbook': brochure('img-p9-3.jpeg'),
  'teaching-library': brochure('img-p10-3.jpeg'),
  'competition-support': '/images/competition-training.png',
  'research-cooperation': brochure('img-p17-2.jpeg'),
}

export function resolveGroupId(categoryId) {
  for (const group of productSidebar) {
    if (group.children.some((c) => c.id === categoryId)) return group.id
  }
  return 'system'
}

export function getGroupVisual(groupId) {
  return groupVisuals[groupId] || groupVisuals.system
}

export const groupDescriptions = {
  system: 'MES/ERP/WMS/OA、数字孪生与新能源云平台',
  education: '实训平台、数字教材与技能大赛全链路服务',
  robotics: '人型机器人、机器狗、AI 与工业无人机定制',
  'agv-group': 'AGV、AMR、叉车与复合移动机器人',
  automation: '非标产线、原创工业产品与案例交付',
}

export const groupTags = {
  system: ['MES / ERP', 'WMS / OA', '数字孪生', '新能源云平台'],
  education: ['实训平台', '数字教材', '技能大赛', '科研合作'],
  robotics: ['人型机器人', '机器狗', 'AI 定制', '工业无人机'],
  'agv-group': ['AGV / AMR', '叉车搬运', '复合机器人', '多机调度'],
  automation: ['非标产线', '原创产品', '案例交付', '柔性制造'],
}

export function getGroupTags(groupId) {
  return groupTags[groupId] || []
}

export function getCategoryVisual(category) {
  if (!category) return ''
  const mapped = categoryVisuals[category.id]
  if (mapped) return mapped
  const hero = category.heroImage || ''
  if (hero.includes('/pdf-pages/')) return ''
  return hero
}
